module.exports = __webpack_public_path__ + "img/costal-7-4.39fea062.jpg";